var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRating(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 14.002L5.5 12.5L4 11.502L5.5 10.5L6.5 9.00195L7.5 10.5L9 11.502L7.5 12.5L6.5 14.002Z",
    fill: "#595959"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 7L9.47487 5.52513L10.9497 2.05025L12.4246 5.52513L15.8995 7L12.4246 8.47487L10.9497 11.9497L9.47487 8.47487L6 7Z",
    fill: "#595959"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRating);
export default __webpack_public_path__ + "static/media/rating.01a53bde3027f91250808317517197b8.svg";
export { ForwardRef as ReactComponent };